import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WorkIndex from "../pages/work/page";
import ProjectDetail from "../pages/work/detail/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/work", element: <WorkIndex /> },
  { path: "/work/:slug", element: <ProjectDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;